enum NotificationSeverity {
  Information,
  Warning,
  Error
}

export default NotificationSeverity;
